export default {
  email_confirm: {
    header: {
      title: 'Email address confirmation complete',
    },
    completed: {
      section_one: 'We have sent your login ID and password to the e-mail address you entered.',
      section_two: 'check your email and follow the instructions in the email to login.',
      section_three: 'If you have not received it after 30 minutes,  please notify us at ',
      section_four: 'The person in charge will contact you again.',
    },
    expired: {
      section_one: 'The URL provided has already expired. ',
      section_two: 'If you wish to use this service, please contact ',
      section_three: 'The person in charge will contact you.',
    },
    btn: {
      service_top: 'Top',
      login: 'Login',
      register: 'Register',
      rating_url: 'https://asuene.com/rating/en',
    },
  },
}
